/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { Button } from '@repo/shared-client/components/ui'
import { Link as TanStackLink } from '@tanstack/react-router'
import { useAuth } from '@web/src/hooks/use-auth'
import { useTranslation } from '@web/src/lib/intl/react'

type VMMenuProps = {
  activeTab?: string
  categoriesRoute?: string
  listRoute?: string
}

const VMMenu = ({
  activeTab = 'discover',
  categoriesRoute = '/vendor-market',
  listRoute = '/vendor-market/list',
}: VMMenuProps) => {
  const { t } = useTranslation()
  const { isAuthenticated } = useAuth()

  const categoriesTo = isAuthenticated ? categoriesRoute : '/auth/signup'
  const listTo = isAuthenticated ? listRoute : '/auth/signup'

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      <Button
        nativeButton={false}
        render={<TanStackLink to={categoriesTo} />}
        variant={activeTab === 'categories' ? 'pill' : 'pill-outline'}
      >
        {t('Categories')}
      </Button>
      <Button
        nativeButton={false}
        render={<TanStackLink to={listTo} />}
        variant={activeTab === 'discover' ? 'pill' : 'pill-outline'}
      >
        {t('Discover')}
      </Button>
    </div>
  )
}

export default VMMenu
